<template>
    <div>
        <ValidationObserver ref="filterForm">
            <b-row>
                <b-col cols="12">
                    <ValidationProvider name="period_id" rules="required" v-slot="{ valid, errors }">
                        <b-form-group
                            :label="$t('period')"
                        >
                            <period-selectbox
                                v-model="form.period_id"
                            ></period-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="product_id" rules="required"
                                        v-slot="{valid, errors}">
                        <b-form-group>
                            <label class="col-form-label pt-0">{{ $t('product') }}</label>
                                <payment-products-selectbox
                                    v-model="form.product_id"
                                >
                                </payment-products-selectbox>
                            <b-form-invalid-feedback v-if="errors[0]"
                                                     v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>


                <b-col cols="12">
                    <ValidationProvider name="file" :rules="'required'" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('excel_file')">
                            <div class="d-flex custom-file-upload">
                                <b-form-file v-model="form.file" :state="errors[0] ? false : (valid ? true : null)"
                                    :placeholder="$t('select_file')" :drop-placeholder="$t('drop_file')"
                                    ref="fileInput"></b-form-file>
                                <b-button variant="outline-secondary" @click="$refs.fileInput.$el.childNodes[0].click();">{{
                                    $t('browse') }}</b-button>
                            </div>
                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div><!--
                            <b-badge variant="primary" class="mt-1">
                                {{ $t('student_number_long') }},
                                {{ $t('program_code') }},
                                {{ $t('course_code') }},
                                {{ $t('letter_grade') }},
                                {{ $t('section') }},
                                {{ $t('lab_section') }},
                                {{ $t('credit') }},
                                {{ $t('ects_credit') }},
                                {{ $t('slot_semester') }},
                                {{ $t('slot_type') }}
                            </b-badge>-->
                        </b-form-group>
                    </ValidationProvider>

                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" class="d-flex">
                    <b-button @click="download('payment_plans_import')" variant="outline-secondary" class="mr-2">{{ $t('download_excel_template') }}</b-button>
                    <b-button variant="primary" @click="save">
                        {{ $t('import') }}
                    </b-button>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>

<script>
import SemestersSelectbox from '@/components/interactive-fields/SemestersSelectbox'

import { ValidationObserver, ValidationProvider } from 'vee-validate'
import excelImportTemplate from "@/services/ExcelImportTemplate";
import PeriodSelectbox from "@/components/interactive-fields/PeriodSelectbox.vue";
import PaymentPlanService from "@/services/PaymentPlanService";
import PaymentProductsSelectbox from "@/components/interactive-fields/PaymentProductsSelectbox.vue";

export default {
    components: {
        PaymentProductsSelectbox,
        PeriodSelectbox,
        SemestersSelectbox,
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            form: {},
        }
    },
    methods: {
        async save() {
            const isValid = await this.$refs.filterForm.validate()

            if (isValid) {
                const formData = new FormData();
                formData.append('period_id', this.form.period_id);
                formData.append('product_id', this.form.product_id);
                formData.append('file', this.form.file);

                PaymentPlanService.paymentPlansImport(formData)
                    .then((response) => {
                        this.$router.push('/job/logs/detail/' + response.data.data.log_id)
                    })
                    .catch((error) => {
                        this.showErrors(error)
                    })
            }
        },
        download(code) {
            excelImportTemplate.downloadTemplate(code)
                .then(response => {
                    this._downloadFile(response, code + '.xlsx')
                })
                .catch(error => {
                    if (error.status == 422) {
                        this.$toast.error(error.data.errors.file[0]);
                    }
                    if (error.status == 406) {
                        this.$toast.error(this.$t('api.' + error.data.message));
                    }
                });
        },
    }
}
</script>
